import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function ItemLegendValues() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-row items-center gap-1"><Skeleton className="bg-input h-3 w-3 rounded-full md:h-4 md:w-4" /><Skeleton className="bg-input h-[10.5px] w-[85px] rounded-md md:h-3.5 md:w-[109px] lg:w-[106px]" /><Skeleton className="bg-input h-[10.5px] w-[15px] rounded-md" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { ItemLegendValues };